import * as Sentry from '@sentry/react';

import { Logger } from './logger';

export function sentryCaptureException(
  ...args: Parameters<typeof Sentry.captureException>
) {
  Logger.error(args[0]);
  if (Sentry.getClient() != null) {
    Sentry.captureException(...args);
  }
}

export function sentrySetUser(user: Sentry.User) {
  Sentry.setUser(user);
}
